<template>
  <div class="following-list">
    <div v-for="customer in usersFollowing" v-bind:key="customer.id" v-if="customer.id !== id" >
      <customer :id="customer.id"></customer>
    </div>
    <div v-if="!loading && usersFollowing.length === 0">
      {{ $t('customer.details.no-friends') }}
    </div>
  </div>
</template>

<script>

import HTTP from '@rocketfid/api'
import { mapGetters } from 'vuex'
import Customer from '@/components/customers/customer-card.vue'

export default {
  name: 'customer-friends-list',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  components: { Customer },

  data () {
    return {
      usersFollowing: [],
      loading: true
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    })
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  methods: {
    init () {
      this.getUsersFollowingByPage(0)
    },

    getUsersFollowingByPage (page) {
      HTTP.axios.get(process.env.API + '/user/' + this.id + '/following/' + page + '/6/')
        .then((result) => {
          this.usersFollowing.push(...result.data)
          this.loading = false
        })
        .catch((result) => {
          this.loading = false
        })
    }
  }
}

</script>

<style lang="scss" scoped>
.following-list {
    height: 400px;
    box-sizing: border-box;
    padding: 12px;
    overflow-y: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/customers/customer-friends-list.vue